<template>
  <div class="results">
    <div class="results__content">
      <h2 class="results__title">{{ labels.results.title }}</h2>
      <accordeon :items="labels.results.faq" class="results__accordeon" />
      <a
        class="results__button"
        :href="labels.results.cta.path"
        target="_blank"
        :download="labels.results.cta.path"
      >{{ labels.results.cta.text }}</a>
    </div>
  </div>
</template>

<script>
import Accordeon from "./Accordeon.vue";
import { mapGetters } from "vuex";
import { vuexGetters } from "../store";
export default {
  name: "Results",
  components: {
    Accordeon
  },
  computed: {
    ...mapGetters({
      labels: vuexGetters.I18N
    })
  }
};
</script>

<style lang="scss" scoped>
.results {
  background: url("../assets/layout/blue-containers.png") no-repeat center
    center;
  @media screen and (min-width: 544px) {
    background-image: url("../assets/layout/blue-containers-desktop.png");
  }
  @include forRetina {
    background-image: url("../assets/layout/blue-containers@2x.png");
    @media screen and (min-width: 544px) {
      background-image: url("../assets/layout/blue-containers-desktop@2x.png");
    }
  }
  background-size: cover;
  position: relative;
  padding: 72px 32px;
  margin-top: 72px;

  &__content {
    position: relative;
    z-index: 5;

    @media screen and (min-width: 544px) {
      max-width: 494px;
      margin: 72px auto 248px;
    }
  }

  &:before {
    background: transparent
      linear-gradient(180deg, #ffffff00 0%, #b19bca7a 38%, #0073cf 100%) 0% 0%
      no-repeat padding-box;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    content: "";
    z-index: 1;
    opacity: 0.64;
  }

  &__title {
    color: $white;
    display: block;
    font-size: 1.25rem;
    font-weight: 300;
    line-height: 1.5rem;
    text-align: center;
    margin-bottom: 35px;

    @media screen and (min-width: 544px) {
      text-align: left;
    }
  }

  &__accordeon {
    color: $white;
    border-bottom: 1px solid $white;
    margin-bottom: 30px;
  }

  &__button {
    background-color: $white;
    border-bottom-right-radius: 26px;
    display: block;
    width: 220px;
    padding: 20px 15px;
    text-decoration: none;
    font-size: 0.9375rem;
    line-height: 1.125rem;
    color: $eminence;
    transition: all 0.4s ease-in-out;
    box-shadow: 0px 0px 50px #00C9FF;
    animation: buttonGlow 2s ease-in-out 0s infinite;

    &:hover {
      animation: none;
      background-color: $eminence;
      color: $white;
    }
  }
}

@keyframes buttonGlow {
  0% {
    box-shadow: 0px 0px 20px #00C9FF
  }

  50% {
    box-shadow: 0px 0px 50px #00C9FF
  }

  100% {
    box-shadow: 0px 0px 20px #00C9FF
  }
}
</style>